import { recordTestInstance } from '../axios';

const getBillingPeriodList = (customerId: any, filters: any) =>
  recordTestInstance.post('/billing-period', { customerId, filters });
export default getBillingPeriodList;